import { Checkbox } from "../ui/checkbox";
import { Field, TextInput } from "../common";
import { textareaClass } from "./fields";

export const PMBubble = ({ title, testId, children }) => (
  <section data-testid={testId} className="min-w-0 rounded-2xl border border-[#84252F]/20 bg-white p-4 sm:p-5 space-y-4">
    <h3 className="text-base md:text-lg font-semibold text-[#84252F] border-b border-[#84252F]/10 pb-2">{title}</h3>
    {children}
  </section>
);

export const PMCheck = ({ label, testId, value, set, disabled }) => (
  <label className="flex min-h-11 gap-3 items-start text-sm leading-relaxed cursor-pointer has-[:disabled]:cursor-default">
    <Checkbox data-testid={testId} className="mt-1" checked={!!value} disabled={disabled} onCheckedChange={(checked) => set(checked === true)} />
    <span className="min-w-0 break-words">{label}</span>
  </label>
);

export const PMField = ({ label, name, data, set, prefix, disabled, type = "text", ...props }) => (
  <div className="min-w-0"><Field label={label}>
    <TextInput testId={`${prefix}-${name}`} type={type} disabled={disabled} value={data[name] ?? ""} maxLength={300}
      onChange={(event) => set(name, type === "number" ? (event.target.value === "" ? null : Number(event.target.value)) : (type === "date" ? event.target.value || null : event.target.value))}
      {...props} />
  </Field></div>
);

export const PMNotes = ({ label, name, data, set, prefix, disabled, maxLength = 5000 }) => (
  <Field label={label}><textarea data-testid={`${prefix}-${name}`} className={textareaClass} rows={3} maxLength={maxLength} value={data[name] || ""} disabled={disabled} onChange={(event) => set(name, event.target.value)} /></Field>
);

export const PMChoices = ({ label, options, value, set, prefix, disabled }) => (
  <div role="group" aria-label={label} className="flex flex-wrap gap-2">
    {options.map(([key, text]) => <label key={key} className={`flex min-h-11 items-center gap-2 rounded-lg border px-3 py-2 text-xs font-medium cursor-pointer transition-colors ${value === key ? key === "fail" ? "border-red-300 bg-red-50 text-red-800" : "border-[#84252F]/40 bg-[#84252F]/5 text-[#84252F]" : "border-slate-200 text-slate-600"}`}>
      <Checkbox data-testid={`${prefix}-${key}`} checked={value === key} disabled={disabled} aria-label={`${label}: ${text}`} onCheckedChange={(checked) => set(checked ? key : null)} />{text}
    </label>)}
  </div>
);
